/**
 * Pre-compiled de messages for MoneyInput
 * Generated by @internationalized/string-compiler
 * DO NOT EDIT MANUALLY
 */

export default {
  amountInputLabel: `Betrag`,
  currencySelectLabel: `Währung`,
  highPrecisionPrice: `Hochpräzisionspreis`,
};
